import { EstimacionInterface, RequisitosInterface } from "@app/admin/pages/oportunidades/helpers/interfaces/propuesta-interface";
import { AnalisisFuncionalInterface } from "./analisis-funcional-interface";
import { ContactoInterface } from "./contacto-interface";
import { IConcepto, IConceptos } from "./IConceptos";
import { ILineaInfraestructura } from "./linea-infraestructura";
import { ProyectoInterface } from "./proyecto-interface";
import { ProyectoTipoInterface } from "./proyecto-tipo-interface";
import { TipoMetodoPagoInterface } from "./tipo-metodo-pago-interface";

export interface ProyectoItemsInterface {
    nombre:                  string;
    nombreModalidad:         NombreModalidad;
    nombreProyecto:          string;
    fechaEstadoActual:       Date;
    idProyectoItemEstado:    string;
    id:                      string;
    identificador:           string;
    idProyectoItemModalidad: string;
    idProyecto:              string;
    idProyectoTipo:        string; //no seguro
    duracion:              string;
    validezDias:           string;
    otrasConsideraciones:  string;
    fecha:                 Date;
    precioTotal:           string;
    descripcion:             string;
    evolucion?:              string;
    esGitlab?: boolean;
    idTipoMetodoPago:      string;
    idObjetoProcedencia: string;
    idProcedencia: string;
    idTipoMedioContacto: string;
    objetoProcedenciaAPI: string;
    fechaFormatt?:        Date;
    proyectoItemEstado:      IProyectoItemEstado;
    proyecto?:               ProyectoInterface;
    tipoMetodoPago?: TipoMetodoPagoInterface;
    proyectoTipo?: ProyectoTipoInterface; //duda
    analisisFuncional?: AnalisisFuncionalInterface;
    lineasInfraestructura?: ILineaInfraestructura[];
    estimacion?: EstimacionInterface;
    requisitos?: RequisitosInterface;
    conceptos?: IConceptos;
    puedoEditarTipoAndNombreProyecto?: boolean;
    idContactoResponsableProyectoItem?: string;
    contactoResponsableProyectoItem?: ContactoInterface
    nombreContactoResponsableProyecto?: string;

}

export enum NombreModalidad {
    Evolutivo = "Evolutivo",
    Horas = "Horas",
    Mantenimiento = "Mantenimiento",
}

export interface IProyectoItemEstado {
    id:         string;
    nombre:     string;
    icono:      string;
    iconoFront: string;
    color:      string;
}

export interface ProyectoItemModalidadesInterface {
    id:              string;
    identificador:   string;
    idCentroCoste:   string;
    nombre:          string;
    descripcion:     string;
    esEvolucionable: boolean;
}


export enum EstadosProyectoItem {
    BorradorOportunidad = '1',
    EnPlanificacion = '2',
    EnCurso = '3',
    Finalizado = '4',
    Pausado = '5',    
    Descartado = '6' 
}


export interface RequestPatchProyecto {
    nombre: string;
    descripcion: string;
    idProyectoTipo: string;
    idProyectoServicio: string;
    idEmpleadoJefeProyecto: string;
}
